import { render, staticRenderFns } from "./BindingAccount.vue?vue&type=template&id=ff668c82&scoped=true"
import script from "./BindingAccount.vue?vue&type=script&lang=js"
export * from "./BindingAccount.vue?vue&type=script&lang=js"
import style0 from "./BindingAccount.vue?vue&type=style&index=0&id=ff668c82&prod&lang=scss"
import style1 from "./BindingAccount.vue?vue&type=style&index=1&id=ff668c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff668c82",
  null
  
)

export default component.exports